import Tracking from '../modules/tracking'

const module = {

    async getAdjustUrl(Vue, ctaName, defaultUrl) {
        let adjustUrl = defaultUrl
        const tracking  = Tracking.getTracking()
        if(Vue.$http) {
            await Vue.$http.get('/service-m/redirect-links.json')
                .then(response => {
                    const rules = response.body
                    const rule = rules.filter(item => item.name === ctaName)[0]

                    if(rule) {
                        const ctaLinks = rule.links
                        ctaLinks.forEach(link => {
                            const conditionsLength = Object.keys(link.conditions).length
                            let validConditions = 0
                            for(const conditionKey in link.conditions) {
                                if(tracking[conditionKey] === link.conditions[conditionKey]) {
                                    validConditions = validConditions +1
                                }
                            }
                            if(validConditions > 0 && validConditions === conditionsLength) {
                                adjustUrl = link.url
                            }
                        })

                    }
                })
        }

        const url = new URL(adjustUrl)

        if(tracking.utm_campaign) { url.searchParams.set('campaign', tracking.utm_campaign) }
        if(tracking.referrer) { url.searchParams.set('referrer', tracking.referrer) }
        if(tracking.utm_source) { url.searchParams.set('utm_source', tracking.utm_source) }

        //android
        if(tracking.utm_source) { url.searchParams.set('utm_medium', tracking.utm_source) }

        //ios
        if(tracking.referrer) { url.searchParams.set('adgroup', tracking.referrer) }
        if(tracking.utm_source) { url.searchParams.set('creative', tracking.utm_source) }

        return url.href
    }
}

export default module